module.exports = __webpack_public_path__ + "img/03-02_Managing conflict.9faa7daf.svg";